<template>
  <Button
    class="mt-3"
    size="lg"
    @click="showModal = !showModal"
    id="openModalBtn"
  >
    Message Us
  </Button>
  <ModalsGeneric :open="showModal" @closeModal="showModal = false">
    <div class="max-w-7xl m-auto w-full pb-3 md:w-[450px]">
      <p class="font-semibold mb-3 mb-md-4">Contact Form</p>

      <template v-if="!messageSent">
        <div>
          <div>
            <input
              class="p-4 border border-blue-light-two rounded-lg w-full mt-2 focus:border active:border focus:border-blue active:border-blue outline-none"
              type="text"
              placeholder="Full Name"
              v-model="form.full_name"
            />
            <p class="mt-2 text-red" v-if="hasError('full_name')">
              {{ errorsFor("full_name") }}
            </p>
          </div>
          <div>
            <input
              class="p-4 border border-blue-light-two rounded-lg w-full mt-2 focus:border active:border focus:border-blue active:border-blue outline-none"
              type="email"
              placeholder="Email"
              v-model="form.email"
            />
            <p class="mt-2 text-red" v-if="hasError('email')">
              {{ errorsFor("email") }}
            </p>
          </div>

          <div>
            <textarea
              class="p-4 border border-blue-light-two rounded-lg w-full mt-2 focus:border active:border focus:border-blue active:border-blue outline-none"
              name="message"
              id="message"
              cols="30"
              rows="8"
              placeholder="Message"
              v-model="form.message"
            ></textarea>
            <p class="mt-2 mb-2 text-red" v-if="hasError('message')">
              {{ errorsFor("message") }}
            </p>
          </div>

          <button
            href="#"
            @click="sendContactForm()"
            class="inline-flex px-3 lg:px-10 py-2 lg:py-3.5 items-center text-white text-sm font-semibold bg-blue-500 border-none rounded-lg tracking-wide"
          >
            Send Message
          </button>
        </div>
      </template>

      <template v-else>
        <h3>Your message has been sent!</h3>
        <p>We'll get back to you as soon as we can.</p>
      </template>
    </div>
  </ModalsGeneric>
</template>
<script setup>
const showModal = ref(false);
const messageSent = ref(false);
const form = reactive({
  full_name: "",
  email: "",
  message: "",
});

const errorStore = useErrorStore();
const { setErrors, hasError, errorsFor } = errorStore;

async function sendContactForm() {
  const { error } = await useFetch(
    useJustHireUrl(`/api/contact-form`),
    {
      headers: useJustHireHeaders(),
      method: "POST",
      body: form,
    }
  );

  if (error.value) {
    setErrors(error.value?.response?._data.data);
    return;
  }

  messageSent.value = true;
}
</script>
